import { render, staticRenderFns } from "./DoctorTemplate.vue?vue&type=template&id=83b41d54&scoped=true"
import script from "./DoctorTemplate.vue?vue&type=script&lang=js"
export * from "./DoctorTemplate.vue?vue&type=script&lang=js"
import style0 from "./DoctorTemplate.vue?vue&type=style&index=0&id=83b41d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b41d54",
  null
  
)

export default component.exports